import { render, staticRenderFns } from "./ModalAddServiceToConsumer.vue?vue&type=template&id=7896d2d2"
import script from "./ModalAddServiceToConsumer.vue?vue&type=script&lang=js"
export * from "./ModalAddServiceToConsumer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7896d2d2')) {
      api.createRecord('7896d2d2', component.options)
    } else {
      api.reload('7896d2d2', component.options)
    }
    module.hot.accept("./ModalAddServiceToConsumer.vue?vue&type=template&id=7896d2d2", function () {
      api.rerender('7896d2d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalAddServiceToConsumer.vue"
export default component.exports